import { render, staticRenderFns } from "./MedicamentoNaoAtendido.vue?vue&type=template&id=4f717a70&"
import script from "./MedicamentoNaoAtendido.vue?vue&type=script&lang=js&"
export * from "./MedicamentoNaoAtendido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports